module.exports = __webpack_public_path__ + "static/media/indus_logo.8e4fdea2.png";